import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

import classNames from 'classnames';

import { Link } from '../Link';
import { EPositionHorizontal, EPositionVertical } from './enum';

import { IDropdownOption, IDropdownProps, IDropdownState } from './types';

import * as s from './Dropdown.scss';

export class DropdownItem extends React.Component<IDropdownProps & RouteComponentProps, IDropdownState> {

	state: IDropdownState = {
		isShowDropdown: this.props.isShowAtStart,
		positionVertical: this.props.positionVertical,
		positionHorizontal: this.props.positionHorizontal,
	};

	nodeRef: React.RefObject<HTMLDivElement> = React.createRef();
	dropdownRef: React.RefObject<HTMLDivElement> = React.createRef();

	componentDidMount() {
		if (this.props.isShowAtStart) {
			document.addEventListener('mousedown', this.onDocumentClick, false);
		}
	}

	componentWillUnmount(): void {
		document.removeEventListener('mousedown', this.onDocumentClick, false);
	}

	setDropdownPosition = () => {
		const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
		const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
		const dropdown = this.dropdownRef?.current;
		const dropdownBounding = dropdown?.getBoundingClientRect();

		if (!!dropdown) {
			let { positionVertical, positionHorizontal } = this.state;

			// если дропдаун уходит за нижнюю границу экрана, раскрываем его вверх и наоборот
			if (dropdownBounding.bottom > viewportHeight) {
				positionVertical = EPositionVertical.TOP;
			} else if (dropdownBounding.top < 0) {
				positionVertical = EPositionVertical.BOTTOM;
			}

			// если дропдаун уходит за правую границу экрана, раскрываем его влево и наоборот
			if (dropdownBounding.right > viewportWidth) {
				positionHorizontal = EPositionHorizontal.LEFT;
			} else if (dropdownBounding.left < 0) {
				positionHorizontal = EPositionHorizontal.RIGHT;
			}

			this.setState({
				positionVertical,
				positionHorizontal,
			});
		}
	};

	toggleDropdown = (isShow?: boolean) => {
		this.setState({
			isShowDropdown: isShow,
		}, this.setDropdownPosition);
	};

	onButtonClick = () => {
		this.props.onClick && this.props.onClick();
		this.toggleDropdown(!this.state.isShowDropdown);

		if (!this.props.isShowAtStart) {
			document.addEventListener('mousedown', this.onDocumentClick, false);
		}
	};

	onDocumentClick = (event: MouseEvent) => {
		const target = event.target as HTMLElement;

		if (this.nodeRef?.current?.contains(target) || this.dropdownRef?.current?.contains(target)) {
			return;
		}

		this.toggleDropdown(false);
		if (!this.props.isShowAtStart) {
			document.removeEventListener('mousedown', this.onDocumentClick, false);
		}
	};

	render() {
		const {
			className,
			buttonClassName,
			options,
			button,
			dropdownWidth,
		} = this.props;
		const verticalPositionClass = this.state.positionVertical === EPositionVertical.TOP
			? EPositionVertical.TOP
			: EPositionVertical.BOTTOM;
		const horizontalPositionClass = this.state.positionHorizontal === EPositionHorizontal.LEFT
			? EPositionHorizontal.LEFT
			: EPositionHorizontal.RIGHT;
		const classNameGenerated = classNames(
			s.dropDown,
			s[verticalPositionClass],
			s[horizontalPositionClass],
		);
		const blockClass = classNames(
			s.block,
			className,
			{ [s.active]: !!this.state.isShowDropdown },
		);

		return (
			<div
				ref={this.nodeRef}
				className={blockClass}
			>
				<div
					onClick={this.onButtonClick}
					className={classNames(s.button, buttonClassName)}
				>
					{
						button || <span>Button</span>
					}
				</div>
				{
					this.state.isShowDropdown &&
						(
							<div
								ref={this.dropdownRef}
								className={classNameGenerated}
								style={{ width: `${dropdownWidth}px` }}
							>
								{
									options.map((option: IDropdownOption, index: number) => {
										return (
											<Link
												to={option.url}
												key={option.title}
												className={s.option}
												onClick={option.onClickAction}
												target={option.isBlank ? '_blank' : ''}
											>
												{option.title}
											</Link>
										);
									})
								}
							</div>
						)
				}
			</div>
		);
	}

}

export const Dropdown = withRouter(DropdownItem);
